<template>
  <div
    class="incoming-tender-list-header incoming-tender-list-row"
    :class="{
      'incoming-tender-list-row_short': !showLabourMaterialTools,
    }"
    @mouseover="showDeleteIcon = true"
    @mouseleave="showDeleteIcon = false"
  >
    <div class="tender-list-cell first-row-full-height">
      <v-tooltip
        v-if="breakdownHeader && showDeleteIcon && versionIsDraft"
        top
        max-width="345"
        transition="scroll-y-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <TrashIcon
              class="primary-500-icon icon-18px pointer"
              @click="$emit('delete-breakdown')"
            />
          </div>
        </template>
        {{ $t('Delete breakdown') }}
      </v-tooltip>
    </div>
    <div class="tender-list-cell first-row-full-height">
      {{ $t('Description of work') }}
    </div>
    <div class="tender-list-cell first-row-full-height">
      {{ $t('Unit') }}
    </div>
    <div class="tender-list-cell first-row-full-height">
      {{ $t('Quantity') }}
    </div>
    <div class="d-contents">
      <div
        class="incoming-tender-list-header__group-title incoming-tender-list-header__per-unit-title"
        :class="{
          'incoming-tender-list-header__per-unit-title_narrow': !showLabourMaterialTools,
        }"
      >
        {{ $t('Per unit') }}
      </div>
      <div v-if="showLabourMaterialTools" class="tender-list-cell tender-list-cell__second-section">
        {{ $t('Labour') }} ≈ {{ currencySymbol }}
      </div>
      <div v-if="showLabourMaterialTools" class="tender-list-cell tender-list-cell__second-section">
        {{ $t('Materials') }} ≈ {{ currencySymbol }}
      </div>
      <div v-if="showLabourMaterialTools" class="tender-list-cell tender-list-cell__second-section">
        {{ $t('Tools') }} ≈ {{ currencySymbol }}
      </div>
      <div class="tender-list-cell tender-list-cell__second-section">
        {{ $t('Total') }} ≈ {{ currencySymbol }}
      </div>
    </div>
    <div class="d-contents">
      <div
        class="incoming-tender-list-header__group-title incoming-tender-list-header__total-title"
        :class="{
          'incoming-tender-list-header__total-title_narrow': !showLabourMaterialTools,
        }"
      >
        {{ $t('Total') }}
      </div>
      <div v-if="showLabourMaterialTools" class="tender-list-cell tender-list-cell__second-section">
        {{ $t('Labour') }} ≈ {{ currencySymbol }}
      </div>
      <div v-if="showLabourMaterialTools" class="tender-list-cell tender-list-cell__second-section">
        {{ $t('Materials') }} ≈ {{ currencySymbol }}
      </div>
      <div v-if="showLabourMaterialTools" class="tender-list-cell tender-list-cell__second-section">
        {{ $t('Tools') }} ≈ {{ currencySymbol }}
      </div>
      <div class="tender-list-cell tender-list-cell__second-section right-sticky-cell">
        {{ $t('Total') }} ≈ {{ currencySymbol }}
      </div>
    </div>
  </div>
</template>

<script>
  import TrashIcon from '@/assets/icons/trash.svg';
  import { VTooltip } from 'vuetify/lib';
  import { mapState } from 'vuex';

  export default {
    name: 'IncomingTenderListHeader',
    components: {
      TrashIcon,
      VTooltip,
    },
    props: {
      showLabourMaterialTools: {
        type: Boolean,
        required: true,
      },
      breakdownHeader: {
        type: Boolean,
        default: false,
      },
      versionIsDraft: {
        type: Boolean,
        default: false,
      },
      currency: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        showDeleteIcon: false,
      };
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
      currencySymbol() {
        return this.currencySymbols[this.currency];
      },
    },
  };
</script>
